import { useState } from "react";

import { images } from "../assets/img";
import { sendContact } from "../api/contact";
import { useAppStore } from "../store/useAppStore";
import { t } from "../utils/utils";

const EMPTY_FORM = { name: "", phone: "", email: "", body: "", website: "" };

function ContactForm() {
  // Re-render labels when the site language changes.
  useAppStore((state) => state.appLang);

  const [form, setForm] = useState(EMPTY_FORM);
  // "idle" | "sending" | "sent" | "error"
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  function update(event) {
    setForm((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  }

  async function submit(event) {
    event.preventDefault();

    setStatus("sending");
    setError("");

    try {
      await sendContact({ ...form, email: form.email.trim() || null });
      setForm(EMPTY_FORM);
      setStatus("sent");
    } catch (error) {
      setError(error.message || t.contactFormError);
      setStatus("error");
    }
  }

  if (status === "sent") {
    return (
      <div className="contactUsForm">
        <p className="contactUsFormNote">{t.contactFormSent}</p>
        <button type="button" onClick={() => setStatus("idle")}>
          {t.contactFormAnother}
        </button>
      </div>
    );
  }

  return (
    <form className="contactUsForm" onSubmit={submit}>
      <input
        name="name"
        placeholder={t.contactFormName}
        value={form.name}
        onChange={update}
        maxLength={100}
        autoComplete="name"
        required
      />
      <input
        name="phone"
        type="tel"
        placeholder={t.contactFormPhone}
        value={form.phone}
        onChange={update}
        maxLength={40}
        autoComplete="tel"
        required
      />
      <input
        name="email"
        type="email"
        placeholder={t.contactFormEmail}
        value={form.email}
        onChange={update}
        maxLength={254}
        autoComplete="email"
      />
      <textarea
        name="body"
        placeholder={t.contactFormMessage}
        value={form.body}
        onChange={update}
        maxLength={5000}
        rows={5}
        required
      />

      {/* Honeypot: hidden from people; bots fill it in and get ignored. */}
      <input
        className="contactUsFormHp"
        name="website"
        value={form.website}
        onChange={update}
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
      />

      {status === "error" && <div className="contactUsFormError">{error}</div>}

      <button type="submit" disabled={status === "sending"}>
        {status === "sending" ? t.contactFormSending : t.contactFormSend}
      </button>
    </form>
  );
}

export function Contacts() {
  return (
    <div id="homeContacts" className="contactUs">
      <div className="cont1">
        <div className="head1">{t.contactUs}</div>
        <div className="contactUsBlock">
          <div className="contactUsList">
            <div className="item">
              <div className="icon">
                <img className="ico" src={images.icon.whatsapp_icon} alt="" />
              </div>
              <div className="info">
                <b>WhatsUp</b>
                <br />
                +44 7448974519
                <br />
                +44 7405654453
              </div>
            </div>
            <div className="item">
              <div className="icon">
                <img
                  className="ico"
                  src={images.icon["inbox-line-svgrepo-com"]}
                  alt=""
                />
              </div>
              <div className="info">
                <b>Email address</b>
                <br />
                accounts@protaxadvisors.co.uk
              </div>
            </div>
            <div className="item">
              <div className="icon">
                <img className="ico" src={images.icon.messanger_icon} alt="" />
              </div>
              <div className="info">
                <b>Messanger</b>
                <br />
                +44 7448974519
                <br />
                +44 7405654453
              </div>
            </div>
          </div>

          <ContactForm />
        </div>
      </div>
    </div>
  );
}
